export default {
  'exportDropdown.export': 'Export',
  'exportDropdown.exportExamResult': 'Export Exam Results',
  'exportDropdown.exportExamStats': 'Export Exam and Question Analysis',
};
